/* "Adapted from: Copyright (c) 2001, Dr Martin Porter, Copyright (c) 2002, Richard Boulton. All rights reserved.
 * Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
 * 1. Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
 * 2. Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer
 * in the documentation and/or other materials provided with the distribution.
 * 3. Neither the name of the copyright holder nor the names of its contributors may be used to endorse or promote products derived
 * from this software without specific prior written permission.
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING,
 * BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 * IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY,
 *  OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS;
 * OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 * The stopwords list was prepared by Anna Tordai from the University of Amsterdam.
 * The original list can be found here: http://snowball.tartarus.org/algorithms/hungarian/stop.txt
 */

/**
 * Returns a list with stopwords for the Hungarian passive voice assessment.
 *
 * @returns {Array}                 The list with stopwords.
 */
export default [
	"a",
	"ahogy",
	"ahol",
	"aki",
	"akik",
	"akkor",
	"alatt",
	"által",
	"általában",
	"amely",
	"amelyek",
	"amelyekben",
	"amelyeket",
	"amelyet",
	"amelynek",
	"ami",
	"amit",
	"amolyan",
	"amíg",
	"amikor",
	"át",
	"abban",
	"ahhoz",
	"annak",
	"arra",
	"arról",
	"az",
	"azok",
	"azon",
	"azt",
	"azzal",
	"azért",
	"aztán",
	"azután",
	"azonban",
	"bár",
	"be",
	"belül",
	"benne",
	"cikk",
	"cikkek",
	"cikkeket",
	"csak",
	"de",
	"e",
	"eddig",
	"egész",
	"egy",
	"egyes",
	"egyetlen",
	"egyéb",
	"egyik",
	"egyre",
	"ekkor",
	"el",
	"elég",
	"ellen",
	"elé",
	"először",
	"előtt",
	"első",
	"én",
	"éppen",
	"ebben",
	"ehhez",
	"emilyen",
	"ennek",
	"erre",
	"ez",
	"ezt",
	"ezek",
	"ezen",
	"ezzel",
	"ezért",
	"és",
	"fel",
	"felé",
	"hanem",
	"hiszen",
	"hogy",
	"hogyan",
	"igen",
	"így",
	"illetve",
	"ill.",
	"ill",
	"ilyen",
	"ilyenkor",
	"ismét",
	"itt",
	"jó",
	"jól",
	"jobban",
	"kell",
	"kellett",
	"keresztül",
	"keressünk",
	"ki",
	"kívül",
	"között",
	"közül",
	"legalább",
	"lehet",
	"lehetett",
	"legyen",
	"lenne",
	"lenni",
	"lesz",
	"lett",
	"maga",
	"magát",
	"majd",
	"majd",
	"már",
	"más",
	"másik",
	"meg",
	"még",
	"mellett",
	"mert",
	"mely",
	"melyek",
	"mi",
	"mit",
	"míg",
	"miért",
	"milyen",
	"mikor",
	"minden",
	"mindent",
	"mindenki",
	"mindig",
	"mint",
	"mintha",
	"mivel",
	"most",
	"nagy",
	"nagyobb",
	"nagyon",
	"ne",
	"néha",
	"nekem",
	"neki",
	"nem",
	"néhány",
	"nélkül",
	"nincs",
	"olyan",
	"ott",
	"össze",
	"ő",
	"ők",
	"őket",
	"pedig",
	"persze",
	"rá",
	"s",
	"saját",
	"sem",
	"semmi",
	"sok",
	"sokat",
	"sokkal",
	"számára",
	"szemben",
	"szerint",
	"szinte",
	"talán",
	"tehát",
	"teljes",
	"tovább",
	"továbbá",
	"több",
	"úgy",
	"ugyanis",
	"új",
	"újabb",
	"újra",
	"után",
	"utána",
	"utolsó",
	"vagy",
	"vagyis",
	"valaki",
	"valami",
	"valamint",
	"való",
	"vissza",
	"viszont",
];
